const recommended_offer_pin = require("../../../maps/images/pins/multi_lead_offer_pin.svg");
const checked_offer_pin = require("../../../maps/images/pins/multi_lead_checked_offer_pin.svg");

export const getApplicationMultiLeadRecommendedMapIcon = (isChecked: boolean) => (isChecked ? checked_offer_pin : recommended_offer_pin);
